module.exports = __webpack_public_path__ + "img/4.cba35252.jpg";